export default "__VITE_ASSET__CwUzvQf0__"